import React, { useEffect, useState, useContext } from "react"
import { SecondaryCard } from "../../components/cards";
import { Rejected } from "../../widgets/SCWidgets";
import productShortName from "../../../../utils/GetProductShortName";
import useIsMounted from "../../../../hooks/useIsMounted";
import { CurrencyLabel } from "../../../common/inputs";
import useApi from '../../../../hooks/useApi';
import widgetService from "../../../../services/invTransactions";
import EntityContext from "../../../../context/entityContext";

export default function RejectedInvoices(){

    const isMounted = useIsMounted();
    const { selectedBusinessType, selProduct, entityDetails } = useContext(EntityContext);
    const [data, setData] = useState(null);

    //------------Api Services-----------------------------------
    const approvedInvoicesApi = useApi(widgetService.getRejectedInvoices);

    const fetchRejectedInvoices = async () => {
        const response = await approvedInvoicesApi.request({ entity_id: entityDetails.a_guid, selectedBusinessType });
        if(response && isMounted()){
            setData({
                topLabel: "Rejected",
                topValue: <CurrencyLabel decimal={2} value={response.data.total_chargeable_amt} />,
                leftLabel: response.data.isPrimary ? "Debtors" : "Clients",
                leftValue: response.data.isPrimary ? response.data.debtor_count : response.data.client_count,
                rightLabel: "Invoices",
                rightValue: response.data.invoice_count,
                bottomRightLabel: "",
                primaryBtnRoute: `/client/${productShortName(selProduct)}/sale-invoices?status=rejected`
            })
        }
    }

    useEffect(() => {
        fetchRejectedInvoices();
    }, [selectedBusinessType, entityDetails])

    return(
        <>
            <Rejected
                type="sm"
                data={data}
                top={true}
                loading={approvedInvoicesApi.loading}
                qrystring={true}
            />
        </>
    )
}